import * as React from "react";
import { css } from "@emotion/react";
import { space } from "main/javascripts/styles/base/spaceStyle";
import { moreThanBreakpoint } from "main/javascripts/styles/base/responsiveStyle";
import {
  fontSize,
  fontWeight,
  lineHeight,
} from "main/javascripts/styles/base/typographyStyle";

interface IProps extends React.AllHTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
}

export const CruiseContentTitle: React.FC<IProps> = (
  props: IProps
): React.ReactElement<IProps> => {
  const { children } = props;
  return <h2 css={titleStyle}>{children}</h2>;
};

const titleStyle = css`
  font-size: ${fontSize.title};
  line-height: ${lineHeight.title};
  font-weight: ${fontWeight.medium};
  padding: ${space.atom2x} 0;
  ${moreThanBreakpoint("desktop")} {
    font-size: 1.75rem;
    line-height: 1.4;
  }
`;
